import { useEffect, useState } from "react";

import { useAppDispatch, useAppSelector } from "@app/store";
import { PARAMS } from "@constants/index";
import { setProducts, useDeleteProductMutation, useLazyGetProductsQuery } from "@modules/product";
import { useUpdateProductConfigurationMutation } from "@modules/product/api/product.api";
import { FilterParams } from "types";
import { toast } from "react-toastify";

export const useProductsListLogic = () => {
  const dispatch = useAppDispatch();
  const productsList = useAppSelector((state) => state.product.products)

  const [getProducts] = useLazyGetProductsQuery()
  const [deleteProduct] = useDeleteProductMutation()
  const [updateConfiguratuin] = useUpdateProductConfigurationMutation()

  const [pagesCount, setPagesCount] = useState<number>(1);
  const [filters, setFilters] = useState<FilterParams>({
    limit: PARAMS.LIMIT,
    offset: PARAMS.OFFSET,
  })

  const handleGetRequest = async () => {
    try {
      const responseProducts = await getProducts(filters).unwrap();

      dispatch(setProducts(responseProducts.products));
      setPagesCount(responseProducts.count || 1)
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteProduct = async (id: string) => {
    if (!id) {
      return null
    }

    try {
      await deleteProduct({ id })
      handleGetRequest()
    } catch (error) {
      console.log(error);
    }
  }

  const handlePagination = (page: number, limit: number) => {
    const offset = page === 1 ? PARAMS.OFFSET : limit * (page - 1)

    setFilters({ limit, offset })
  }

  const handleChange = ({
    key,
    data,
    productId,
  }: {
    data: boolean;
    productId: string;
    key: 'bestSeller' | 'activeInHome';
  }) => {
    if (!productId) {
      return
    }

    updateConfiguratuin({
      id: productId,
      body: { [key]: data },
    })
      .unwrap()
      .then(() => {
        const updated = productsList?.map((item) => {
          if (item.id === productId) {
            return { ...item, [key]: data }
          }

          return item
        })

        dispatch(setProducts(updated));
      })
      .catch((error) => {
        console.log(error);
        if (error?.data?.message) {
          toast(error?.data?.message, { type: 'warning' })
        }
      })
  }

  useEffect(() => {
    handleGetRequest()
  }, [filters])

  return {
    productsList,
    handleChange,
    handleDeleteProduct,
    pagesCount,
    handlePagination
  }
}
